import { auth, adminRedirect } from 'routing/common';

export default [...auth, ...adminRedirect];
